module.exports = __webpack_public_path__ + "static/legends-1-38513fd7c42aa2e53017467ea407e3d2.jpg";